module.exports = __webpack_public_path__ + "resources/reduce-size-e5af2bb891ba70165c78123387e3138a.svg";